import { combineReducers } from 'redux';

import qualityMonitor from './quality-monitor/reducers';

export default combineReducers({
  qualityMonitor
});
